import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SelectQuestion as SelectQuestionType } from "./questionTypes";
import { SelectAnswer } from "./answerTypes";
import { useState } from "react";

interface SelectQuestionProps {
  question: SelectQuestionType;
  value: SelectAnswer | undefined;
  onChange: (questionId: string, value: SelectAnswer) => void;
}

export function SelectQuestion({ question, value, onChange }: SelectQuestionProps) {
  const [showOtherInput, setShowOtherInput] = useState(value?.value === "other");

  const handleSelectChange = (selectedValue: string) => {
    setShowOtherInput(selectedValue === "other");
    
    if (selectedValue === "other") {
      onChange(question.id, {
        type: 'select',
        value: selectedValue,
        otherValue: value?.otherValue || ""
      });
    } else {
      onChange(question.id, {
        type: 'select',
        value: selectedValue
      });
    }
  };

  const handleOtherChange = (otherValue: string) => {
    onChange(question.id, {
      type: 'select',
      value: "other",
      otherValue
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor={question.id} className="text-base font-medium">
          {question.title}
        </Label>
        {question.description && (
          <p className="text-sm text-muted-foreground">{question.description}</p>
        )}
      </div>
      
      <Select value={value?.value || ""} onValueChange={handleSelectChange}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={question.placeholder} />
        </SelectTrigger>
        <SelectContent>
          {question.options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {showOtherInput && question.allowOther && (
        <div className="mt-2">
          <Input
            type="text"
            placeholder={question.otherPlaceholder || "Please specify"}
            value={value?.otherValue || ""}
            onChange={(e) => handleOtherChange(e.target.value)}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
}